<template>
  <div class="tree">
      <ul v-if="trackingTestResult && Object.keys(trackingTestResult).length > 0">
        <li class="" v-for="(events, key) in trackingTestResult" :key="key">
          <span class="parent">
            <div class="box url-text">{{key}}</div>
          </span>
          <ul>
            <li v-for="event in events" :key="event.id">
              <span class="child">
                <div class="box event flex justify-between">
                  <span class="text-left">
                    <span>{{event.event}}</span>
                  </span>

                  <span class="text-right">
                    <span class="event-status active-icon"></span>
                    <span>{{ $t('Active')}}</span>
                  </span>
                </div>
              </span>
            </li>
          </ul>
        </li>
      </ul>
      <ul v-else-if="status === this.$constants.TRACKING_TEST_STATUS.DONE">
        <li class="mb-3 mt-3">
          <span class="parent">
            <div class="box url-text px-4 py-3">{{testURL}}</div>
          </span>
          <ul>
            <li>
              <span class="child">
                <div class="box event flex justify-between">
                  <span class="text-left pl-1">
                    <span class="event-status danger-icon"></span>
                    <span>{{ $t('No pixel found')}}</span>
                  </span>
                </div>
              </span>
            </li>
          </ul>
        </li>
      </ul>
  </div>
</template>

<script>

export default {
  props:['trackingTestResult', 'testURL', 'status']
}
</script>

<style lang="scss" scoped>
$active-color: #21ba45;
$inactive-color:#f2af03;
$danger-color:#db2828;
$border-color:#c2c2c2;
$text-color: #323232;

.event-status {
  height: 10px;
  width: 10px;
  margin-right: 6px !important;

  @apply mr-1;

  &.active-icon {
    background: $active-color;
  }

  &.inactive-icon {
    background: $inactive-color;
  }

  &.danger-icon {
    background: $danger-color;
  }
}

.box {
  box-sizing: border-box;
  border-radius: 4px;
  color: $text-color;

  &.url-text {
    padding: 12px;
    overflow-wrap: break-word;
    border: 1px solid $border-color;
  }

  &.event {
    width: 278px;
    padding: 8px 12px 8px 12px;
    height: 36px;
    border: 1px dashed $border-color;
  }
}

.tree li {
  list-style-type: none;
  margin: 0;
  padding: 10px 5px 0 5px;
  position: relative;
}

.tree li::before,
.tree li::after {
  content: '';
  left: 10px;
  position: absolute;
  right: auto;
  border-radius: 4px;
}

.tree li::before {
  bottom: 10px;
  height: 100%;
  top: 0;
  width: 0;
  border: 1px dashed $border-color;
}

.tree li::after {
  height: 20px;
  top: 30px;
  width: 20px;
  border-top: 1px dashed $border-color;
}

.tree li span {
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  display: inline-block;
  text-decoration: none;
}

.tree > ul > li::before,
.tree > ul > li::after {
  border: 0;
}

.tree li:last-child::before {
  top: 0;
  height: 28px;
}

span.child {
  margin-left: 22px;;
}

@media (max-width: 768px) {
  .tree li {
    padding-left: 0;
  }

  .url-text {
    max-width: 284px;
    overflow: hidden;
  }

  .box.event {
    width: 262px;
  }

  .tree li::before {
    top: -10%;
  }

  .tree li::after {
    width: 14px;
  }
}
</style>
